var map = {
	"./Alchimeia_island.png": "./src/assets/img/world_map/islands/with_label/Alchimeia_island.png",
	"./Fabella_island.png": "./src/assets/img/world_map/islands/with_label/Fabella_island.png",
	"./Lumina_island.png": "./src/assets/img/world_map/islands/with_label/Lumina_island.png",
	"./Morbida_island.png": "./src/assets/img/world_map/islands/with_label/Morbida_island.png",
	"./Oracle_island.png": "./src/assets/img/world_map/islands/with_label/Oracle_island.png",
	"./Sylva_island.png": "./src/assets/img/world_map/islands/with_label/Sylva_island.png",
	"./Temperus_island.png": "./src/assets/img/world_map/islands/with_label/Temperus_island.png",
	"./Veritas_island.png": "./src/assets/img/world_map/islands/with_label/Veritas_island.png"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "./src/assets/img/world_map/islands/with_label sync recursive ^\\.\\/.*_island\\.png$";